
export default function IconCreateAgents() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 15.0822V10.5013C6.75 9.65801 6.07843 8.97437 5.25 8.97437H3.75C2.92157 8.97437 2.25 9.65801 2.25 10.5013V15.0822C2.25 15.9255 2.92157 16.6091 3.75 16.6091H5.25C6.07843 16.6091 6.75 15.9255 6.75 15.0822ZM6.75 15.0822V7.44741C6.75 6.6041 7.42157 5.92046 8.25 5.92046H9.75C10.5784 5.92046 11.25 6.6041 11.25 7.44741V15.0822M6.75 15.0822C6.75 15.9255 7.42157 16.6091 8.25 16.6091H9.75C10.5784 16.6091 11.25 15.9255 11.25 15.0822M11.25 15.0822V4.3935C11.25 3.55019 11.9216 2.86655 12.75 2.86655H14.25C15.0784 2.86655 15.75 3.55019 15.75 4.3935V15.0822C15.75 15.9255 15.0784 16.6091 14.25 16.6091H12.75C11.9216 16.6091 11.25 15.9255 11.25 15.0822Z"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
